/**
 * our harriApp passed to the function
 *
 * @type {Object} harriApp
 * @namespace ManageForm
 */
(function (app) {
    "use strict";

    /**
     * Form validation without create new file for this on hForm
     *
     * @param scope
     * @param className
     * @private
     */
    var _formValidation = function (scope, className) {
        var self = this;
        var _protected = BaseForm.call(self, className, scope);
    };

    /**
     * Safe digest without the angular error that say angular already in digest progress
     *
     * @param scope
     */
    var safeDigest = function (scope) {
        scope.$$phase || scope.$root && scope.$root.$$phase || scope.$digest();
    };

    /**
     *
     * @param scope
     * @param fn
     */
    var safeApply = function(scope, fn) {
        var root = scope.$root || {};
        var phase = root.$$phase;

        if(phase === '$apply' || phase === '$digest') {
            if(fn && (typeof(fn) === 'function')) {
                fn();
            }
        } else {
            scope.$apply(fn);
        }
    };

    /**
     * @typedef {Object} MangeTemplatesFormController
     * This component is needed to show form to edit or delete or add new rejection template
     * on 'HARRI_BASE_URL/settings/rejection_templates/brand/brand_id'
     * or
     * on 'HARRI_BASE_URL/ams/job_id'
     */

    /**
     * Construct a new MangeTemplatesFormController
     *
     * @class MangeTemplatesFormController
     * @classdesc rejection template setting form and ams skip form.
     *
     * @constructor
     */
    var MangeTemplatesFormController = function ($scope, Upload) {
        var self = this;

        /**
         * Rejection form selector
         *
         * @type {string}
         */
        var FORM_SELECTOR = 'rejection-templates-manage-form';

        /**
         * This is the first point on this component
         *
         * @type {Function[]}
         */
        var onInit = function () {
            /**
             * Clear validation every time we show this form
             * @type {{}}
             */
            self.formValidator.validator.validation = {};

            /**
             * The rejection template item
             *
             * @type {{}}
             */
            self.item = self.item || {};

            /**
             * make sure that attachments defined even there is no attachment for this template
             * @type {Array}
             */
            self.item.attachments = self.item.attachments || [];

            /**
             * Disable fields if this template rejection not allowed to edit
             * @type {*|boolean}
             */
            self.viewOnly = self.item.viewOnly;

            /**
             * Is Rejection template a system template
             * @type {*|boolean}
             */
            self.isSystemTemplate = self.item.isSystemTemplate;

            /**
             * Save if the rejection item is new
             * @type {boolean}
             */
            self.newItem = !self.item.id;

            /**
             * For rejection template some field are smart fields and we save them on BE as {BRAND_NAME}
             * so i need to change this {BRAND_NAME} to {{BRAND_NAME}}
             */
            if (self.item.message) {
                self.item.message = Utils.escapeHtml(self.item.message);

                self.item.message = self.item.message.replace(/\{.*?\}/g, function(tag) {
                    tag = tag.replace('{', '');
                    tag = tag.replace('}', '');

                    return '{{' + tag + '}}&#160';
                });
            }

            /**
             * same as above
             */
            if (self.item.subject) {
                self.item.subject = Utils.escapeHtml(self.item.subject);

                self.item.subject = self.item.subject.replace(/\{.*?\}/g, function(tag) {
                    tag = tag.replace('{', '');
                    tag = tag.replace('}', '');

                    return '{{' + tag + '}}&#160';
                });
            }

            /**
             * change the delay from seconds to string format like this MM:SS or set them as 00:00
             */
            if (self.item.delay) {
                // convert from seconds to string as HH:mm
                var delay = parseInt(self.item.delay);
                var fullHours = delay / (60 * 60);
                var hours = Math.floor(fullHours);
                var minutes = Math.round((((fullHours * 100) % 100) / 100) * 60);

                if (hours < 10) {
                    hours = '0' + hours;
                }

                if (minutes < 10) {
                    minutes = '0' + minutes;
                }

                self.item.delay = hours + ':' + minutes;
            } else {
                self.item.delay = '00:00';
            }
        };

        /**
         * The default value for template rejection
         * @type {{}}
         */
        self.item = {};

        /**
         * default value for delay on template rejection
         * @type {string}
         */
        self.item.delay = '00:00';

        /**
         * make sure that attachments defined even there is no attachment for this template
         * @type {Array}
         */
        self.item.attachments = self.item.attachments || [];

        /**
         * This to handle when user attach files to this rejection template,
         * check if the files attached are valid and show message for invalid files
         * we have two invalid cases the first one is not valid type & not valid size
         * valid size: 7MB
         * valid types: pdf, png or jpeg
         * the alert used here is our hAlert
         * @param files
         */
        self.addAttachments = function (files) {

            if (files && files.length) {
                var notValidTypeMessage = ['<p>' + $filter('translate')('The attached file(s) could not be uploaded:') + '</p>', '<ul>'];
                var notValidSizeMessage = ['<p>' + $filter('translate')('The attached file(s) could not be uploaded:') + '</p>', '<ul>'];
                var showSizeErrorMessage;
                var showTypeErrorMessage;

                for (var i in files) {
                    var file = files[i];
                    var fileType = file.type;

                    var validType = fileType === 'image/jpeg' || fileType === 'image/png' || fileType.indexOf('pdf') > -1;
                    var validSize = file.size <= 7000000;

                    if (validType && validSize) {
                        file.tmp = true;
                        self.item.attachments.push(file);
                    }

                    if (!validType) {
                        notValidTypeMessage.push('<li>' + file.name + '</li>');
                        showTypeErrorMessage = true;
                    }

                    if (!validSize) {
                        notValidSizeMessage.push('<li>' + file.name + '</li>');
                        showSizeErrorMessage = true;
                    }
                }

                notValidTypeMessage.push('</ul>');
                notValidTypeMessage.push('<p>' + $filter('translate')('You can only attach a file(s) of type pdf, png or jpeg.') + '</p>');

                notValidSizeMessage.push('</ul>');
                notValidSizeMessage.push('<p>' + $filter('translate')('The file(s) exceeds the maximum size of 7MB.') + '</p>');

                if (showTypeErrorMessage) {
                    hAlert(
                        $filter("translate")("Invalid Files"),
                        notValidTypeMessage.join(''),
                        function () {},
                        'rejection-templates-error-alert'
                    );
                } else if (showSizeErrorMessage){
                    hAlert(
                        $filter("translate")("Invalid Files"),
                        notValidSizeMessage.join(''),
                        function () {},
                        'rejection-templates-error-alert'
                    );
                }
            }
        };

        /**
         * Remove the selected attachment by its index on self.item.attachments array
         * @param index
         */
        self.removeAttachment = function (index) {
            self.item.attachments.splice(index, 1);
        };

        /**
         * This to delete the whole rejection template if its already added to the BE
         * API used: harri_code/brands/brandId/templates/templateId
         */
        self.delete = function () {
            var item = jQuery.extend(true, {}, self.item);

            hConfirm({
                text: $filter("translate")("Are you sure you want to delete this template?"),
                callback: function (confirmed) {
                    if (confirmed) {
                        self.loading = true;
                        safeDigest($scope);

                        BrandAPI.deleteBrandRejectionTemplate(self.brandId, item.id)
                            .then(function () {
                                self.events['templateItemDeleted'](item.id);

                                self.loading = false;
                                safeApply($scope);
                            }, function (err) {
                                self.loading = false;
                                safeApply($scope);

                                hAlert(
                                    $filter("translate")("Something went wrong!"),
                                    $filter("translate")(err),
                                    function () {},
                                    'rejection-templates-error-alert'
                                );
                            });
                    }
                }
            });
        };

        /**
         * Block the send rejection when additional event needed like send skip reasons
         */
        self.saveSteps = function () {
            if (self.formValidator.validator.validate()) {
                var promises = {};

                if (self.additionalAction && (['ams', 'my_docs'].indexOf(self.source) > -1)) {
                    var fireOnSkipModal = false;
                    var hideTheModal = false;

                    promises['additional_action'] = self.additionalActionWrapper(fireOnSkipModal, !hideTheModal);
                }

                $q.all(promises)
                    .then(function () {
                        self.save();
                    });
            }
        };

        /**
         * This to handle both edit and add new rejection template
         * check if the entered data are valid then save API
         * There is two APIs used here on this method:
         * API 1: to send rejection template to candidates harri_code/brand/brandId/job/self.jobId/templates/send
         * API 2: to create or update rejection template on setting page brands/brandId/templates
         */
        self.save = function () {
            if (self.formValidator.validator.validate()) {
                /**
                 * This used to get a copy from template rejection object
                 * angular.extend not working here because i need a deep copy with files array
                 */
                var item = jQuery.extend(true, {}, self.item);

                delete item.loading;

                /**
                 * The attachment ids need if this is edit or send and already saved on database
                 * @type {Array}
                 */
                item.attachments_ids = [];

                /**
                 * Loop through attachment and get the one have id already and saved on DB
                 */
                for (var i = item.attachments.length - 1; i >= 0; i--) {
                    var attachment = item.attachments[i];

                    if (item.id && attachment.id) {
                        item.attachments_ids.push(attachment.id);
                        item.attachments.splice(i, 1);
                    } else {
                        delete attachment.tmp;
                    }
                }

                /**
                 * convert the delay from string(00:00) to seconds(0)
                 * @type {Array|*}
                 */
                var splitDelay = item.delay.split(':');
                var hours = parseInt(splitDelay[0]);
                var minutes = parseInt(splitDelay[1]);

                item.delay = (hours * 60 * 60) + (minutes * 60);

                /**
                 * set template type or category to API
                 * @type {string}
                 */
                item['category'] = 'REJECTION';

                /**
                 * Get application id from AMS to send them the template and delete title because its not needed on AMS
                 * @type {Array}
                 */
                if (['ams', 'my_docs'].indexOf(self.source) > -1) {
                    item.application_ids = [];

                    for (var i in self.rejectionCandidates) {
                        var candidate = self.rejectionCandidates[i];
                        item.application_ids.push(candidate.application_id);
                    }

                    delete item.title;
                }

                /**
                 * delete unnecessary attributes that used from FE on template rejection item
                 */
                delete item.viewOnly;
                delete item.type;
                delete item.$$hashKey;
                delete item.updated;

                if (item.isSystemTemplate) {
                    delete item.id;
                }
                delete item.isSystemTemplate;

                self.loading = true;

                /**
                 * create the URL or end point to send the request to it using the template if there is and id or not
                 * and replace the view smart field from {{BRAND_NAME}} to {BRAND_NAME} to replace them by BE
                 */
                var url;
                var method;

                item.message = item.message.replace(/{{/g, '{');
                item.message = item.message.replace(/}}\s/g, '}}').replace(/}}/g, '}');

                item.subject = item.subject.replace(/{{/g, '{');
                item.subject = item.subject.replace(/}}\s/g, '}}').replace(/}}/g, '}');

                item.message = Utils.escapeHtml(item.message);
                item.subject = Utils.escapeHtml(item.subject);

                /**
                 * End points from send and edit or add new rejection template on setting
                 */
                if (['ams', 'my_docs'].indexOf(self.source) > -1) {
                    delete item.id;

                    url = publicConfiguration.APIServerBaseURL + 'brands/' + self.brandId + '/jobs/' + self.jobId + '/message_templates/send';
                    method = 'POST';
                } else {
                    url = publicConfiguration.APIServerBaseURL + 'brands/' + self.brandId + '/message_templates';
                    method = 'POST';

                    if (item.id) {
                        url = url + '/' + item.id;
                        method = 'PUT';
                    }
                }

                /**
                 * This ng-upload service to request API using multipart request
                 * there is two promise callback fail and success
                 * the success one trigger the templateItemManaged event on the parent component
                 * the fail one show a modal told the user that we have error or something went wrong
                 */
                Upload.upload({
                    'url':  url,
                    'withCredentials': true,
                    'headers': {},
                    'method': method,
                    'data': item,
                    'Content-Type': 'multipart/form-data',
                    'arrayKey': '[]'
                }).progress(function (evt) {
                }).success(function (data, status, headers, config) {
                    if (data.status_code == 200) {
                        delete self.item;

                        if (typeof (data.data) === 'object') {
                            data.data.newItem = self.newItem;
                            data.data.updated = new Date(data.data.updated);
                        }

                        self.events['templateItemManaged'](data.data);
                    } else {
                        var errorBody = '';

                        if (data && data.data && Array.isArray(data.data)) {
                            for (var i in data.data) {
                                if (data.data[i].error) {
                                    errorBody += '<p class="text-uppercase"><b>' + data.data[i].error + '</b></p>';
                                }
                            }
                        }

                        hAlert(
                            $filter("translate")("Something went wrong!"),
                            errorBody || '<p>' + JSON.stringify($filter("translate")(data.data)) + '</p>',
                            function () {},
                            'rejection-templates-error-alert'
                        );
                    }

                    self.loading = false;
                }).error(function (reason) {
                    hAlert(
                        $filter("translate")("Something went wrong!"),
                        '<pre>' + JSON.stringify($filter("translate")(reason)) + '</pre>',
                        function () {},
                        'rejection-templates-error-alert'
                    );

                    self.loading = false;
                });
            }
        };

        /**
         * There is a clear action on the template rejection view
         * then call the onInit to reset the data
         */
        self.clearTemplateLoaded = function () {
            delete self.selectedTemplateId;
            delete self.item;

            onInit();
        };

        /**
         * hide the modal if cancel clicked
         */
        self.cancel = function (isError) {
            self.events['hideModal'](isError);
        };

        /**
         * Create form validator to show validation on the view
         * @type {_formValidation}
         */
        self.formValidator = new _formValidation($scope, FORM_SELECTOR);

        /**
         * Custom validation not implemented on our baseForm.js and formValidator
         *
         * @param field
         * @param optionsField
         * @param rule
         * @param showError
         * @returns {boolean}
         */
        self.formValidator.validator.validateCustom = function (field, optionsField, rule, showError) {
            var value =  self.formValidator.validator.getFieldValue(field);

            switch (rule.name) {
                case "time":
                    if (value) {
                        var test = /^([0-4][0-8]):?([0-5]\d)$/.test(value.trim());

                        if (test) {
                            var splitValue = value.split(":");
                            var hours = parseInt(splitValue[0]);
                            var minutes = parseInt(splitValue[1]);

                            if (hours === 48 && minutes > 0) {
                                return false;
                            }
                        } else {
                            return false;
                        }
                    }

                    break;

                case 'duplicate-title':
                    if (['ams', 'my_docs'].indexOf(self.source) === -1) {
                        self.tempaltes = self.templates || {};

                        for (var i in self.templates) {
                            var template = self.templates[i];

                            if (
                                value &&
                                value.toLowerCase().trim() === template.title.toLowerCase().trim() &&
                                template.id !== self.item.id
                            ) {
                                return false;
                            }
                        }
                    }

                    break;
            }

            return true;
        };

        self.selectedTemplateId = null;

        /**
         * Smart fields change event to save the value for message body
         * @param value
         */
        self.onMessageBodyChanged = function (value) {
            if  (self.item) {
                self.item.message = value;
            }
        };

        /**
         * Smart fields change event to save the subject body
         * @param value
         */
        self.onSubjectChanged = function (value) {
            if  (self.item) {
                self.item.subject = value;
            }
        };

        /**
         * On skip modal action to send skip reason without rejection template
         */
        self.additionalActionWrapper = function (fireSKip, hide) {
            var defer = $q.defer();

            self.loading = true;

            self.additionalAction({fireSkipItEvent: fireSKip, preventHideModal: hide})
                .then(
                    function (res) {
                        defer.resolve(res);

                        self.loading = false;
                        $scope.$digest();
                    }, function (err) {
                        var error = true;

                        self.cancel(error);

                        var errorBody = $filter("translate")('Something went wrong please try again later');

                        if (err && err.error && err.error.code) {
                            if (err.error.code === 'NO_SKIP_REASON') {
                                errorBody = '<p>' + $filter("translate")("The selected reason is no longer available") + '</p>';
                            } else if (err.error.code === 'SERVICE_DISABLED') {
                                errorBody = '<p>' + $filter("translate")("Reasons for skipping service has been deactivated") + '</p>';
                            }
                        }

                        hAlert(
                            $filter("translate")("Something went wrong!"),
                            $filter("translate")(errorBody),
                            function () {},
                            'rejection-templates-error-alert'
                        );

                        defer.reject(err);
                        self.loading = false;
                        $scope.$digest();
                    }
                );

            return defer.promise;
        };

        /**
         * Used on ams to give user way to change the template to send to candidates
         */
        self.templateItemChanged = function () {
            delete self.item;

            if (self.selectedTemplateId) {
                for (var i in self.templates) {
                    var template = self.templates[i];

                    if (template.id === parseInt(self.selectedTemplateId)) {
                        self.item = jQuery.extend(true, {}, template);
                        break;
                    }
                }
            } else {
                delete self.selectedTemplateId;
            }

            onInit();
        };

        /**
         * Called on each controller after all the controllers on an element
         *
         * @type {Function[]}
         */
        self.$onInit = function () {
            self.loading = true;

            /**
             * Get Template Smart Fields for this component
             */
            BrandAPI.getTemplateSmartFields('REJECTION')
                .then(function (smartFields) {
                    self.smartFields = smartFields;

                    for (var l in self.smartFields) {
                        self.smartFields[l]["name"] = $filter("translate")(self.smartFields[l]["name"]);
                    }

                    var newItemGet;

                    if (typeof (self.templateItem) !== 'undefined')  {
                        self.item = jQuery.extend(true, {}, self.templateItem);
                        newItemGet = true;
                    }

                    if (typeof (self.candidates) !== 'undefined') {
                        self.rejectionCandidates = jQuery.extend(true, [], self.candidates);
                        newItemGet = true;
                    }

                    if (newItemGet) {
                        onInit();
                    }

                    self.loading = false;
                    $scope.$digest();
                });
        };

        /**
         * Called whenever one-way bindings are updated
         *
         * @param changesObj
         * @param {Object} changesObj.templateItem
         * @param {Array} changesObj.candidates
         */
        self.$onChanges = function (changesObj) {
            var changed;

            if (
                changesObj.templateItem &&
                !changesObj.templateItem.isFirstChange() &&
                JSON.stringify(changesObj.templateItem.currentValue) !== JSON.stringify(changesObj.templateItem.previousValue)
            ) {
                if (changesObj.templateItem.currentValue) {
                    self.item = jQuery.extend(true, {}, changesObj.templateItem.currentValue);
                } else {
                    delete self.item;
                }

                changed = true;
            }

            if (
                changesObj.candidates &&
                !changesObj.candidates.isFirstChange() &&
                JSON.stringify(changesObj.candidates.currentValue) !== JSON.stringify(changesObj.candidates.previousValue)
            ) {
                self.rejectionCandidates = jQuery.extend(true, [], changesObj.candidates.currentValue);
                changed = true;
            }

            if (changed) {
                onInit();
            }
        };

        /**
         * Called after this controller's element and its children have been linked.
         * Attach validation events to the needed dom
         *
         * @type {Function[]}
         */
        self.$postLink = function () {
            self.formValidator.onViewLoaded();
        };
    };

    /**
     *
     * @type {Object}
     */
    var MangeTemplatesForm = {
        bindings: {
            templateItem: '<',
            brandId: '<',
            events: '<',
            templates: '<',
            candidates: '<',
            jobId: '<',
            saveButtonText: '@',
            source: '@',
            skipBucketCandidates: '<',
            additionalAction: '&',
            additionalActionTitle: '<',
            showAdditionalAction: '<',
            loading: '<'
        },
        templateUrl: '../modules/rejection-templates/components/manage-templates-form/manage-templates-form.html',
        controller: ['$scope', 'Upload', MangeTemplatesFormController],
        controllerAs: 'ManageForm'
    };

    app.component('mangeRejectionTemplatesForm', MangeTemplatesForm);
})(angular.module('harriApp.rejectionTemplates'));